module.exports = __webpack_public_path__ + "img/eye_closed.75d25970.svg";